module.exports = __webpack_public_path__ + "img/sushitatarmicrooverviewthunfisch.f29bfdc7.jpg";